/* @flow */

import setEventos from './cadastro-estabelecimento';
import './Main';

setEventos();
